import React from 'react';
import { useAppSelector } from '../../../app/hooks';
import { checkPermission } from '../../../features/auth/authSlice';
import { PERMISSIONS } from '../../constants';
import AccessDenied from './AccessDenied';

function PrivateRoute({
  children,
  permissions,
}: {
  children: React.ReactElement | null;
  permissions?: Array<PERMISSIONS>;
}) {
  const hasPermission = useAppSelector(checkPermission(permissions));

  if (!hasPermission) {
    return <AccessDenied />;
  }

  return children;
}

export default PrivateRoute;
